import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.PhotoSessions.Tabs.title',
    defaultMessage: 'Suas sessões',
  },
  notStartedPhotoSessions: {
    id: 'app.containers.PhotoSessions.Tabs.notStartedPhotoSessions',
    defaultMessage: 'Não iniciadas',
  },
  reschedulePhotoSessions: {
    id: 'app.containers.PhotoSessions.Tabs.reschedulePhotoSessions',
    defaultMessage: 'Reagendar',
  },
  startedPhotoSessions: {
    id: 'app.containers.PhotoSessions.Tabs.startedPhotoSessions',
    defaultMessage: 'Pendentes',
  },
  photoSessionDetailError: {
    id: 'app.containers.PhotoSessions.Tabs.photoSessionDetailError',
    defaultMessage: 'Não foi possível ver detalhes da sessão. Tente mais tarde.',
  },
  startedPhotoSessionsError: {
    id: 'app.containers.PhotoSessions.Tabs.startedPhotoSessionsError',
    defaultMessage: 'Não conseguimos carregar suas sessões de fotos pendentes.',
  },
  notStartedPhotoSessionsError: {
    id: 'app.containers.PhotoSessions.Tabs.notStartedPhotoSessionsError',
    defaultMessage: 'Não conseguimos carregar sua agenda de sessões de fotos.',
  },
  tryAgain: {
    id: 'app.containers.PhotoSessions.Tabs.tryAgain',
    defaultMessage: 'Tente novamente',
  },
  listErrorSubtitle: {
    id: 'app.containers.PhotoSessions.listErrorSubtitle',
    defaultMessage: 'Suas sessões continuam agendadas. Verifique sua conexão e tente de novo.',
  },
  startedPhotoSessionsEmptyStateTitle: {
    id: 'app.containers.PhotoSessions.startedPhotoSessions.EmptyState.Title',
    defaultMessage: 'Sem sessões pendentes',
  },
  startedPhotoSessionsEmptyStateSubTitle: {
    id: 'app.containers.PhotoSessions.startedPhotoSessions.EmptyState.SubTitle',
    defaultMessage: 'Não há sessões de fotos pendentes.',
  },
  notStartedPhotoSessionsEmptyStateTitle: {
    id: 'app.containers.PhotoSessions.notStartedPhotoSessions.EmptyState.Title',
    defaultMessage: 'Sem sessões agendadas',
  },
  notStartedPhotoSessionsEmptyStateSubTitle: {
    id: 'app.containers.PhotoSessions.notStartedPhotoSessions.EmptyState.SubTitle',
    defaultMessage: 'Não há sessões de fotos disponíveis.',
  },
  reschedulePhotoSessionsEmptyStateTitle: {
    id: 'app.containers.PhotoSessions.reschedulePhotoSessions.EmptyState.Title',
    defaultMessage: 'Sem sessões para reagendar',
  },
  reschedulePhotoSessionsEmptyStateSubTitle: {
    id: 'app.containers.PhotoSessions.reschedulePhotoSessions.EmptyState.SubTitle',
    defaultMessage: 'Não há sessões com problema para reagendar.',
  },
});
